import { injectable } from "@launchtray/tsyringe-async";
import { PlayerModel } from "../models/player/PlayerModel";

@injectable()
export class PlayerController {
    public constructor(
        private readonly playerModel: PlayerModel
    ) { }

    public getBestScore(): number {
        return this.playerModel.BestScore;
    }

    public setBestScore(value: number): void {
        this.playerModel.BestScore = value;
    }

    public resetScore(): void {
        this.playerModel.Score = 0;
    }

    public addScore(value: number): void {
        this.playerModel.Score += value;
    }

    public getScore(): number {
        return this.playerModel.Score;
    }

    public resetShuffles(): void {
        this.playerModel.Shuffles = this.playerModel.initialShuffles;
    }

    public addShuffles(value: number): void {
        this.playerModel.Shuffles += value;
    }

    public addEraseBooster(value: number): void {
        this.playerModel.eraseBooster.setValue(this.playerModel.eraseBooster.value + value);
    }

    public addEraseTrianglesBooster(value: number): void {
        this.playerModel.eraseTrianglesBooster.setValue(this.playerModel.eraseTrianglesBooster.value + value);
    }

    public reduceShuffles(): void {
        this.playerModel.Shuffles--;
    }

    public getShuffles(): number {
        return this.playerModel.Shuffles;
    }

    public reduceRevival(): void {
        this.playerModel.reduceRevival();
    }

    public isHaveRevivals(): boolean {
        return this.playerModel.isHaveRevivals();
    }

    public resetRevivals(): void {
        this.playerModel.resetRevivals();
    }

    public setFirstLaunch(): void {
        this.playerModel.IsFirstLaunch = false;
    }

    public resetBoosters(): void {
        this.playerModel.resetAllBoosters();
    }
}